

	import {
		Vue,
		Component
	} from 'vue-property-decorator'
	@Component({
		name: 'report',
		components:{
		}
	})
	export default class contractinfoaa extends Vue {
		gzffForm = {month:[],type:0,reportType:4,userid:'',ly:'',monthOne: ''}
		loading = false
		checkers = []
		allLy = []
		pickerOptions = {
		disabledDate:(time:Date) => {
			return (this.maxAndMinMonth.min&&(time.getTime() < this.maxAndMinMonth.min.getTime()))|| (this.maxAndMinMonth.max&&(time.getTime() > this.maxAndMinMonth.max.getTime()));
		},
	}
		maxAndMinMonth:{min?:Date,max?:Date}={min:undefined,max:undefined}
		rules= {
			reportType: [
				{ required: true, message: '请选择类别', trigger: 'change' }
			],
			type: [
				{ required: true, message: '请选择用工性质', trigger: 'change' }
			],
			userid: [
				{ required: true, message: '请选择用户', trigger: 'change' }
			]
		}
		created() {
			this.findMaxAndMinMonth()
		}
		mounted() {
			this.getAllLy("")

			// this.dataLists = salarydata
		}
		querySearch(queryString:string, cb:(arg0: any)=>{}) {

			// 调用 callback 返回建议列表的数据
			cb(this.allLy);
		}
		getAllLy(month: any) {
			this.$request({
				method: 'get',
				url: '/bjba/salary/getAllLy',
				params: {month: month}
			}).then(res => {
				this.allLy = res.data.data
				// this.dataList = res.data.data
			}).catch(error => {
				this.loading = false
			})
		}
		changeMonth(e: any) {
			// console.log("改变月份 -- 获取到的值为：", e)
			this.getAllLy(e)
			this.gzffForm.ly = ""
		}
		searchChecker(query:string) {
			if (query !== '') {
				this.loading = true;
				// setTimeout(() => {
				//   this.loading = false;
				//   this.options = this.list.filter(item => {
				//     return item.label.toLowerCase()
				//             .indexOf(query.toLowerCase()) > -1;
				//   });
				// }, 200);
				this.$request.get('/bjba/yhgl/findUserListByxm',{
					params: {
						xm:query,
						type: this.gzffForm.type
					}

				}).then(res => {
					this.loading =false
					this.checkers = res.data.data

				})
			} else {
				this.checkers = [];
			}
		}
		// exportGzff() {
		// 	this.$refs['form'].validate((valid:boolean) => {
		// 		if (valid) {
		// 			let reportUrl = '';
		// 			if (this.gzffForm.reportType === 0) reportUrl = 'getGzfsExcel'
		// 			else if (this.gzffForm.reportType === 1) reportUrl = 'getGzHzExcel'
		// 			else if (this.gzffForm.reportType === 2) reportUrl = 'getZyTzExcel'
		// 			var viewUrl = `${this.$request.defaults.baseURL}/bjba/salary/${reportUrl}?beginMonth=${this.gzffForm.month[0]}&endMonth=${this.gzffForm.month[1]}&type=${this.gzffForm.type}&userid=${this.gzffForm.userid}&access_token=${this.$store.getters.token}`
		// 			window.open(viewUrl)
		// 		}
		// 	});
		// }
		reviewGzff() {
			this.$refs['form'].validate((valid:boolean) => {
				if (valid) {
					let reportUrl = '';
					if (this.gzffForm.reportType === 0) {
						if (!this.gzffForm.month[0] || !this.gzffForm.month[1]) {
							this.$message.error("请选择月份")
							return
						}
						reportUrl = 'gzffreport'
					}
					else if (this.gzffForm.reportType === 1) {
						if (!this.gzffForm.month[0] || !this.gzffForm.month[1]) {
							this.$message.error("请选择月份")
							return
						}
						reportUrl = 'gzhzreport'
					}
					else if (this.gzffForm.reportType === 2) {
						if (!this.gzffForm.month[0] || !this.gzffForm.month[1]) {
							this.$message.error("请选择月份")
							return
						}
						reportUrl = 'zytzreport'
					}
					else if (this.gzffForm.reportType === 3) {
						if (!this.gzffForm.monthOne) {
							this.$message.error("请选择月份")
							return
						}
						reportUrl = 'gzjsreport'
					}
					else if (this.gzffForm.reportType === 4) {
						if (!this.gzffForm.monthOne) {
							this.$message.error("请选择月份")
							return
						}
						reportUrl = 'gzdreport'
					}
					// var viewUrl = `${this.$request.defaults.baseURL}/bjba/salary/${reportUrl}?beginMonth=${this.gzffForm.month[0]}&endMonth=${this.gzffForm.month[1]}&type=${this.gzffForm.type}&userid=${this.gzffForm.userid}&access_token=${this.$store.getters.token}`
					// window.open(viewUrl)
					var viewUrl = ``
					this.$router.push({
						path: `/salary/${reportUrl}/view`,
						query: { beginMonth:  this.gzffForm.month[0],endMonth: this.gzffForm.month[1],type: this.gzffForm.type+'',userid: this.gzffForm.userid,month:this.gzffForm.monthOne,ly:this.gzffForm.ly }
					});
				}
			});
		}
		changeTypeGzff(value?:number) {
			this.gzffForm.userid = ''
			this.checkers=[]
			this.gzffForm.month = []
			this.gzffForm.monthOne = ''
			if (value !==undefined && value !== '') {
				this.findMaxAndMinMonth()

			}
		}
		findMaxAndMinMonth() {
			this.$request({
				url: '/bjba/salaryStatus/findMaxAndMinMonthByType',
				params:{type:this.gzffForm.type},
				method: 'get'
			}).then(res => {
				// console.log(res.data.data)
				if (res.data.data && res.data.data.max && res.data.data.min) {
					this.maxAndMinMonth.max = this.$moment(res.data.data.max , "YYYY-MM").toDate()
					this.maxAndMinMonth.min = this.$moment(res.data.data.min , "YYYY-MM").toDate()
				}
			})
		}
	}
